import React, { useEffect } from 'react';
import HomeHero from '../components/home/HomeHero';
import HomeTrustBar from '../components/home/HomeTrustBar';
import HomeHowItWorks from '../components/home/HomeHowItWorks';
import HomeFeaturesOverview from '../components/home/HomeFeaturesOverview';
import HomeModules from '../components/home/HomeModules';
import HomeSecurity from '../components/home/HomeSecurity';
import HomeFinalCta from '../components/home/HomeFinalCta';
import HomeFooter from '../components/home/HomeFooter';
import '../components/home/home.css';
import './HomeLanding.css';

const HomeLanding = () => {
  useEffect(() => {
    const root = document.documentElement;
    root.classList.add('home-page-scroll');
    return () => root.classList.remove('home-page-scroll');
  }, []);

  return (
    <div className="home-landing">
      <HomeHero />
      <HomeTrustBar />
      <HomeHowItWorks />
      <HomeFeaturesOverview />
      <HomeModules />
      <HomeSecurity />
      <HomeFinalCta />
      <HomeFooter />
    </div>
  );
};

export default HomeLanding;
